import { z } from 'zod/v4';

/**
 * The canonical offer price breaks, by the column suffix their prices are stored under. A demand
 * is priced at the largest break it reaches, as `demandQualifiedPriceSql` in monitoring-service does.
 */
export const MARKET_SAVINGS_PRICE_BREAKS = ['1', '100', '1k', '10k', '50k'] as const;
export const MarketSavingsPriceBreakSchema = z.enum(MARKET_SAVINGS_PRICE_BREAKS);
export type MarketSavingsPriceBreak = z.infer<typeof MarketSavingsPriceBreakSchema>;

export const MARKET_SAVINGS_PRICE_BREAK_QUANTITIES = {
    '1': 1,
    '100': 100,
    '1k': 1_000,
    '10k': 10_000,
    '50k': 50_000,
} as const satisfies Record<MarketSavingsPriceBreak, number>;

/** The break a demand is priced at; null for a demand below one piece, which no break covers. */
export function marketSavingsPriceBreakForDemand(demand: number | null | undefined): MarketSavingsPriceBreak | null {
    if (typeof demand !== 'number' || !(demand >= 1)) return null;
    return MARKET_SAVINGS_PRICE_BREAKS.findLast(
        (priceBreak) => demand >= MARKET_SAVINGS_PRICE_BREAK_QUANTITIES[priceBreak],
    )!;
}
